export default {
  admin: {
    notifications: {
      index: '/notifications'
    },
    agencies: {
      root: '/api/agencies',
      withId: function (id) {
        return '/api/agencies/' + id
      },
      basicStats: '/api/agencies/basic-stats'
    },
    users: {
      root: '/api/users/admins',
      withId: function (id) {
        return '/api/users/admins/' + id
      }
    },
    candidate: {
      importCSV: '/api/candidates/import'
    },
    reports: {
      statistics: '/dashboard-statistics'
    }
  }
}
